<template>
  <div>
    <div v-for="(message, i) in errorMessages" :key="`error-${i}`">
      <v-alert
        value="error"
        dismissible
        type="error"
        role="alert"
        aria-live="assertive"
      >
        {{message}}
      </v-alert>
    </div>

    <div v-for="(message, i) in infoMessages" :key="`info-${i}`">
      <v-alert
        value="info"
        dismissible
        type="info"
        role="alert"
        aria-live="assertive"
      >
        {{message}}
      </v-alert>
    </div>

    <div v-for="(message, i) in successMessages" :key="`success-${i}`">
      <v-alert
        value="success"
        dismissible
        type="success"
        role="alert"
        aria-live="assertive"
      >
        {{message}}
      </v-alert>
    </div>

    <div v-for="(message, i) in persistentMessages" :key="`persistent-${i}`">
      <v-alert
        value="persistentMessage"
        dismissible
        type="info"
        role="alert"
        aria-live="assertive"
      >
        {{message}}
      </v-alert>
    </div>
  </div>
</template>

<script>
import StoreMixin from '@/store/mixin'

export default {
  mixins: [StoreMixin],
  computed: {
    errorMessages () {
      return Object.values(this.$store.state.errors)
    },
    infoMessages () {
      return Object.values(this.$store.state.info)
    },
    successMessages () {
      return Object.values(this.$store.state.successes)
    },
    persistentMessages () {
      return Object.values(this.$store.state.persistentMessages)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Notifications.vue